// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/sample-development/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const sampleDevelopmentEN: PageEntry = {
  id: "post.musterentwicklung",
  locale: "en",
  slug: "sample-development",
  seo: {
    title: "Glossary: Sample development explained simply | Dietz GmbH",
    description: "Sample development describes the advanced process of turning sample designs into tangible prototypes or models. This step takes place after the creation of sample designs and is cr",
  },
  type: "post",
  h1: "Glossary: Sample development explained simply",
  intro: "Sample development describes the advanced process of turning sample designs into tangible prototypes or models. This step takes place after the creation of sample designs and is crucial to verify the feasibility, functionality and aesthetics of the design. In various industries, from fashion to product development, pattern development plays a central role in translating ideas into physical models that serve as the basis for pattern creation and construction.",
  blocks: [

  ],
};
